var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.26 12.74V.26h5.89v1.33H1.58v9.83h9.83V6.85h1.33v5.89zm4.82-3.89-.92-.93 6.33-6.33H7.14V.26h5.59v5.59H11.4V2.52L5.07 8.85Z"
})));
export default SvgExternalLink2;